import { Collapsible as ParagonCollapsible } from '@edx/paragon';
import * as React from 'react';

interface CollapsibleProps extends React.PropsWithChildren {
    title: string | React.ReactNode;
    defaultOpen: boolean;
    isCollapsible: boolean;
    isOpen?: boolean;
    onToggle?: (open: boolean) => void;
    onOpen?: () => void;
    onClose?: () => void;
}

export class Collapsible extends React.PureComponent<CollapsibleProps> {

    public static defaultProps = {
        defaultOpen: false,
        isCollapsible: true,
    };

    public render() {
        return (
            <ParagonCollapsible.Advanced
                className='collapsible' defaultOpen={this.props.defaultOpen} open={this.isOpen()}
                onToggle={this.props.onToggle} onOpen={this.props.onOpen} onClose={this.props.onClose}>

                {this.renderTrigger()}

                <ParagonCollapsible.Body className='collapsible-body' transitionWrapper={<></>}>
                    {this.props.children}
                </ParagonCollapsible.Body>

            </ParagonCollapsible.Advanced>
        );
    }

    private renderTrigger() {
        if (!this.props.isCollapsible) {
            return this.props.title;
        }

        return (
            <ParagonCollapsible.Trigger className='collapsible-trigger'>
                {this.props.title}
            </ParagonCollapsible.Trigger>
        );
    }

    private isOpen() {
        return !this.props.isCollapsible || this.props.isOpen;
    }
}
